import { useState } from "react";
import { useTranslation } from "react-i18next";

const useFormValidation = () => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const validationRules = {
    name: [
      (value) => !value?.trim() ? t("commons.errors.requiredField", { fieldName: t("commons.labels.name") }) : "",
      (value) => value?.length < 2 ? t("commons.errors.minLength", { fieldName: t("commons.labels.name"), count: 2 }) : "",
    ],
  };

  const validate = (values) => {
    const validationErrors = {};

    // Validation Name
    if (validationRules.name) {
      for (const rule of validationRules.name) {
        const errorMsg = rule(values.name);
        if (errorMsg) {
          validationErrors.name = [errorMsg];
          break;
        }
      }
    }

    // Tous les champs d'adresse sont facultatifs pour l'organisme : aucune validation.

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const clearErrors = () => { setErrors({}); };

  return { errors, validate, clearErrors };
};

export default useFormValidation;